import katex from "katex";
import "katex/dist/katex.min.css";

const escapeHtml = (str) =>
  str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const render = (tex, display) => {
  try {
    return katex.renderToString(tex, {
      displayMode: display,
      throwOnError: false,
      strict: false,
    });
  } catch {
    return escapeHtml(tex);
  }
};

/**
 * Renders text containing inline ($...$) and block ($$...$$) LaTeX.
 */
export const MathText = ({ text, className = "", block = false, "data-testid": testId }) => {
  if (text === undefined || text === null) return null;
  const html = String(text)
    .split(/(\$\$[\s\S]+?\$\$|\$[^$]+?\$)/g)
    .map((seg) => {
      if (seg.startsWith("$$") && seg.endsWith("$$")) return render(seg.slice(2, -2), true);
      if (seg.startsWith("$") && seg.endsWith("$")) return render(seg.slice(1, -1), false);
      return escapeHtml(seg).replace(/\n/g, "<br/>");
    })
    .join("");
  const Tag = block ? "div" : "span";
  return <Tag data-testid={testId} className={className} dangerouslySetInnerHTML={{ __html: html }} />;
};
